// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"bb7a197b","285":"74f59c10","516":"a6281f3f","625":"64669f0f","636":"744e4adb","762":"bed0ba88","811":"fe0ccd05","887":"3d5e4538"}[chunkId] + ".chunk.js";
};